const getCommonCalendarList = (
  data: any,
  isSingleStudioPage: boolean = false,
  meetingCardAccess: boolean,
): CommonCalendarDataTypes => {
  let res: CommonCalendarDataTypes = null;
  if (!data || !Array.isArray(data)) return res;
  res = [];
  for(let i = 0, l = data?.length; i < l; i ++) {
    const t = data?.[i];
    const list: CommonCalendarCardDataTypes = Array.isArray(t?.detail) ? t?.detail?.map((it: any) => {
      return {
        ...it,
        uniqueId: `${t?.date}_${it?.id}`,
        isTBC: it?.date_confirm == '2',
        milestone: it?.name,
        projectName: it?.project_name,
        projectId: it?.id,
        projectId2: it?.studio_id,
        meetingId: it?.id,
        type: it?.category === 'milestone' ? 1 : it?.category === 'management' ? 0 : -1,
        isExpire: it?.is_expire,
        isJump: it?.view_detail,
        // 详情页Management卡片跳转的权限是用页面的权限判断的
        isJump2: isSingleStudioPage ? meetingCardAccess : it?.view_meeting,
        isSingleStudioPage,
      };
    }) : null;
    res.push({
      ...t,
      list,
    });
  }

  return res;
}

export {
  getCommonCalendarList,
}
